/**
 * @filedesc: 公共接口
 */

import request from '../request'

const URL = {
  findListByReceive: '/company/findListByReceive', // 底部公司信息
  login: '/user/lr/login', // 登录
  getCurrentUserInfo: '/user/getCurrentUserInfo', // 当前用户信息
  findBannerListByReceive: '/advertisement/findBannerListByReceive', // 轮播图
  userTabsList: '/frontMenu/getFrontMenuByLoginInfo', // 获取用户权限Tab页签
  bannerFindById: '/advertisement/findById/', // 轮播详述详情
}

const Common = {
  /**
   *  底部公司信息
  */
  findListByReceive (reqData) {
    return request.put(URL.findListByReceive, reqData)
  },
  // 登录
  login (reqData) {
    return request.put(URL.login, reqData)
  },
  // 资讯头轮播图
  findBannerListByReceive (reqData) {
    return request.put(URL.findBannerListByReceive, reqData)
  },
  // 当前用户信息
  getCurrentUserInfo () {
    return request.get(`${URL.getCurrentUserInfo}?_dt=${new Date().getTime()}`)
  },
  // 获取用户权限Tab页签
  getUserTabs (params) {
    return request.get(URL.userTabsList, params)
  },
  // 轮播详情
  bannerFindById (id) {
    return request.get(`${URL.bannerFindById}/${id}?_dt=${new Date().getTime()}`)
  },
}
export default Common
